module.exports = __webpack_public_path__ + "img/hr-light-mud-decal-27.58e418e5.png";